import { Box, Stack, Theme, Typography, useTheme } from '@mui/material';
import { LogOutIcon } from '@shared/custom-icons';
import { ContainedButton, Paper, SidebarMenuProps, SidebarUserAvatar } from '@shared/components';
import { useSharedTranslation } from '@shared/i18n';

export function RetailExpandedUserMenu({
  userName,
  userPicture,
  jobTitle,
  logOut,
}: Omit<SidebarMenuProps, 'expandedView'>) {
  const { t } = useSharedTranslation();
  const theme = useTheme();

  return (
    <Stack>
      <Paper
        sx={{
          width: '100%',
          padding: theme.spacing(1.5, 2),
          boxShadow: theme.shadows[5],
          border: '1px solid rgba(200, 196, 219, 0.1)',
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="space-between"
          sx={{ borderRadius: 6, backgroundColor: 'background.paper' }}
        >
          <Stack direction="row" alignItems="center" mb={2}>
            <SidebarUserAvatar username={userName} userPicture={userPicture} />

            <Box ml={0.5} display="flex" flexDirection="column">
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                {userName.length > 18 ? `${userName.slice(0, 18)}...` : userName}
              </Typography>

              {jobTitle && (
                <Typography
                  variant="body3"
                  sx={{
                    fontWeight: 500,
                    color: 'grey.400',
                  }}
                >
                  {jobTitle}
                </Typography>
              )}
            </Box>
          </Stack>

          <ContainedButton
            onClick={logOut}
            fullWidth
            sx={{
              background: (theme: Theme) => theme.vars.palette.nav?.surface,
              color: 'nav.textMuted',
              boxShadow: 'none',
              '&:hover': {
                color: 'nav.text',
                background: (theme: Theme) => theme.vars.palette.nav?.activeDark,
              },
            }}
          >
            <Box sx={{ mr: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <LogOutIcon fontSize="small" />
            </Box>
            {t('shared.logOut')}
          </ContainedButton>
        </Stack>
      </Paper>
    </Stack>
  );
}
